"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSaveStatusProvider = exports.AutoSaveStatusContext = exports.AutoSaveStatus = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importStar(require("react"));
var AutoSaveStatus;
(function (AutoSaveStatus) {
    AutoSaveStatus["IDLE"] = "idle";
    AutoSaveStatus["SAVING"] = "saving";
    AutoSaveStatus["DONE"] = "done";
    AutoSaveStatus["ERROR"] = "error";
})(AutoSaveStatus = exports.AutoSaveStatus || (exports.AutoSaveStatus = {}));
exports.AutoSaveStatusContext = react_1.default.createContext({
    status: AutoSaveStatus.IDLE,
    resetStatus() { },
    errors: [],
    triggerAutoSave() { },
    resolveAutoSave() { },
});
function AutoSaveStatusProvider({ children, resetToIdleTimeout = 6000 }) {
    const [status, setStatus] = (0, react_1.useState)(AutoSaveStatus.IDLE);
    const [errors, setErrors] = (0, react_1.useState)([]);
    const [inFlight, setInFlight] = (0, react_1.useState)(0);
    const resetToIdleTimeoutRef = (0, react_1.useRef)(null);
    /** Handles setting Status */
    (0, react_1.useEffect)(() => {
        if (inFlight > 0)
            return setStatus(AutoSaveStatus.SAVING);
        if (status === AutoSaveStatus.IDLE)
            return;
        if (errors.length)
            return setStatus(AutoSaveStatus.ERROR);
        return setStatus(AutoSaveStatus.DONE);
    }, [errors.length, inFlight, status]);
    const triggerAutoSave = (0, react_1.useCallback)(() => {
        setInFlight((c) => c + 1);
        setErrors([]);
    }, []);
    const resolveAutoSave = (0, react_1.useCallback)((error) => {
        setInFlight((c) => Math.max(0, c - 1));
        if (error)
            setErrors((errs) => errs.concat(error));
    }, []);
    const resetStatus = (0, react_1.useCallback)(() => {
        setStatus(AutoSaveStatus.IDLE);
        setErrors([]);
    }, []);
    /** Resets AutoSaveStatus from "Done" to "Idle" after a timeout, if one is provided */
    (0, react_1.useEffect)(() => {
        if (resetToIdleTimeout === undefined)
            return;
        // Specifically avoid auto-reset if Errors are present
        if (status !== AutoSaveStatus.DONE)
            return;
        // Only run the latest Timeout
        if (resetToIdleTimeoutRef.current)
            clearTimeout(resetToIdleTimeoutRef.current);
        resetToIdleTimeoutRef.current = window.setTimeout(() => {
            resetStatus();
            resetToIdleTimeoutRef.current = null;
        }, resetToIdleTimeout);
    }, [resetStatus, resetToIdleTimeout, status]);
    const value = (0, react_1.useMemo)(() => ({ status, resetStatus, errors, triggerAutoSave, resolveAutoSave }), [errors, resetStatus, resolveAutoSave, status, triggerAutoSave]);
    return (0, jsx_runtime_1.jsx)(exports.AutoSaveStatusContext.Provider, { value: value, children: children });
}
exports.AutoSaveStatusProvider = AutoSaveStatusProvider;
